import React from 'react'
import Artiste from 'components/blocks/Artiste';


const ArtisteCatalog = props => {
    const artisteArray = [
        {name:"Falz", occupation:"Musician", imageUrl:"/images/png/falz.png", numberOfSongs:"4,000"},
        {name:"Ninola", occupation:"Musician", imageUrl:"/images/png/nini.png", numberOfSongs:"4,000"},
        {name:"Patoranking", occupation:"Musician", imageUrl:"/images/png/pat.png", numberOfSongs:"4,000"},
        {name:"Falz", occupation:"Musician", imageUrl:"/images/png/falz.png", numberOfSongs:"4,000"},
        {name:"Ninola", occupation:"Musician", imageUrl:"/images/png/nini.png", numberOfSongs:"4,000"},
        {name:"Patoranking", occupation:"Musician", imageUrl:"/images/png/pat.png", numberOfSongs:"4,000"}
    ];
    return (
        <div className="row mx-0">
            {
                artisteArray.map( (artiste, index) => (
                    <div className="col-md-3">
                        <Artiste
                            key={index}
                            name={artiste.name}
                            occupation={artiste.occupation}
                            imageUrl={artiste.imageUrl}
                            numberOfSongs={artiste.numberOfSongs}/>
                    </div>
                ))
            }
            <div className="w-100 my-3">
                <div className="col-md-3 mx-auto">
                    <div className="nsForm-btn box box-xs box--grey-border">View more</div>
                </div>
            </div>
        </div>
    )
}

export default ArtisteCatalog;